export default "/static/dashboard/build/app/img/v2/8b8c5cf0d8830d829857807d5d8530a4.png";